const initialState = {
  total: 0,
};
const TotalYearGrossMarginReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_TOTAL_YEAR_GROSS_MARGIN":
      return (initialState.total = action.payload);
    default:
      return state;
  }
};

export default TotalYearGrossMarginReducer;
